import {styled} from "styled-components";

export const Layout = styled.div`
    display: flex;
    min-height: 100vh;
`;


export const Content = styled.main`
    flex: 1;
    padding: 27px 45px 0 44px;
    background-color: white;
    font-size: 14px;
`;

export const ContainerIgnorePadding = styled.div`
    margin-left: -44px;
    margin-right: -45px;
    width: calc(100% + 89px);
`
